import React, { ReactNode } from 'react';
import { NewRoleGuard } from '~/common/providers/auth/NewRoleGuard';
import { Role } from '~/common/providers/auth/role';

type DashboardRoleGuardProps = {
  children?: ReactNode;
};

// 権限範囲の狭い順に定義する（dashboardAdminRoles ⊂ dashboardAllowedRoles）。
// 編集制限ONでも全件編集でき、編集制限の設定/解除トグルを操作できる管理者ロール
const dashboardAdminRoles: Role[] = ['LOGLASS_SYSTEM_ADMIN', 'TENANT_ADMIN'];

// ダッシュボードにアクセスできる全ロール（編集制限機能では編集可能なロールとして扱う）
const dashboardAllowedRoles: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
  'MANAGER',
  'GENERAL',
];

const DashboardRoleGuard = React.memo(function DashboardRoleGuard({
  children,
}: DashboardRoleGuardProps) {
  return (
    <NewRoleGuard allowedRoles={dashboardAllowedRoles} withErrorToast={true}>
      {children}
    </NewRoleGuard>
  );
});

export { DashboardRoleGuard, dashboardAdminRoles, dashboardAllowedRoles };
